import { GetAllImpuestosDtoProps } from "./DTOs/GetAllImpuestosDto"
import { GetImpuestoEmpresaByIdDtoProps } from "./DTOs/GetImpuestoEmpresaByIdDto"
import { ImpuestoEmpresaReadingDtoProps } from "./DTOs/ImpuestoEmpresaReadingDto"

export const impuestoEmpresaReadingDtoAdapter = (
  impuesto: ImpuestoEmpresaReadingDtoProps
) => ({
  id: impuesto.id,
  cuentaContableEmpresa: impuesto.cuentaContableEmpresa,
  esActivo: impuesto.esActivo,
  grupoImpuesto: impuesto.grupoImpuesto,
  nombre: impuesto.nombre,
  porDefecto: impuesto.porDefecto,
  tipo: impuesto.tipo,
  valor: impuesto.valor,
  clave: impuesto.clave,
})

export const impuestoEmpresaNewReadingDtoAdapter = (
  impuesto: GetAllImpuestosDtoProps
) => ({
  id: impuesto.id,
  clave: impuesto.clave,
  cuentaContable: impuesto.cuentaContable,
  esActivo: impuesto.esActivo,
  grupo: impuesto.grupo,
  nombre: impuesto.nombre,
  porDefecto: impuesto.porDefecto,
  tipo: impuesto.tipo,
  valor: impuesto.valor,
})

export const impuestoEmpresaByIdAdapter = (
  impuesto: GetImpuestoEmpresaByIdDtoProps
): GetImpuestoEmpresaByIdDtoProps => ({
  id: impuesto.id,
  cuentaContableId: impuesto.cuentaContableId,
  esPorDefecto: impuesto.esPorDefecto,
  grupoId: impuesto.grupoId,
  nombre: impuesto.nombre,
  tipo: impuesto.tipo,
  valor: impuesto.valor,
})
